<div [ngClass]="isGuestView ? 'max-w-5xl mx-auto' : 'px-4 lg:px-0'">
  <div class="page-container">
    <div class="relative page-edge-cut">
      <div class="form-card">
        <section class="space-y-3">
          <h1 class="section-heading">
            {{
              "BUSINESS_GROUP.QUESTIONARIES.TITLE"
                | translate: { groupName: groupName }
            }}
          </h1>
          <p class="text-base! text-dc-gray-light">
            {{ "BUSINESS_GROUP.QUESTIONARIES.INTRODUCTION" | translate }}
          </p>
        </section>
        <div class="max-w-3xl space-y-8">
          <section>
            <app-validation-message
              type="info"
              [content]="member_info"
            />
          </section>
          <form
            [formGroup]="form"
            (ngSubmit)="submitQuestionnaire()"
            class="space-y-8"
          >
            <div class="fields-container">
              <div class="field-control">
                <app-text-field
                  [label]="
                    ('BUSINESS_GROUP.QUESTIONARIES.NOMINEE_FULL_NAME'
                      | translate)
                  "
                  [placeholder]="
                    'BUSINESS_GROUP.QUESTIONARIES.NOMINEE_FULL_NAME_PLACEHOLDER'
                      | translate
                  "
                  [control]="form.controls.nomineeFullName"
                />
              </div>
              <div class="field-control">
                <app-text-field
                  [label]="
                    ('BUSINESS_GROUP.QUESTIONARIES.EMAIL_ADDRESS' | translate)
                  "
                  [placeholder]="
                    'BUSINESS_GROUP.QUESTIONARIES.EMAIL_ADDRESS_PLACEHOLDER'
                      | translate
                  "
                  [control]="form.controls.emailAddress"
                  [validationMessages]="{ email: 'VALIDATION_MSG.VALID_EMAIL' | translate }"
                  type="email"
                />
              </div>
              <div class="field-control">
                <app-text-field
                  [label]="
                    ('BUSINESS_GROUP.QUESTIONARIES.MOBILE_NUMBER' | translate)
                  "
                  [placeholder]="
                    'BUSINESS_GROUP.QUESTIONARIES.MOBILE_NUMBER_PLACEHOLDER'
                      | translate
                  "
                  [control]="form.controls.mobileNumber"
                  [validationMessages]="{ mobile: 'VALIDATION_MSG.VALID_MOBILE_NUMBER' | translate }"
                  type="tel"
                />
              </div>
              <div class="field-control">
                <app-text-field
                  [label]="
                    ('BUSINESS_GROUP.QUESTIONARIES.COMPANY_NAME' | translate)
                  "
                  [placeholder]="
                    'BUSINESS_GROUP.QUESTIONARIES.COMPANY_NAME_PLACEHOLDER'
                      | translate
                  "
                  [control]="form.controls.companyName"
                />
              </div>
              <div class="field-control">
                <app-text-field
                  [label]="
                    ('BUSINESS_GROUP.QUESTIONARIES.TRADE_LICENSE_NUMBER'
                      | translate)
                  "
                  [placeholder]="
                    'BUSINESS_GROUP.QUESTIONARIES.TRADE_LICENSE_NUMBER_PLACEHOLDER'
                      | translate
                  "
                  [control]="form.controls.tradeLicenseNumber"
                />
              </div>
              <div class="field-control">
                <app-text-field
                  [label]="
                    ('BUSINESS_GROUP.QUESTIONARIES.CURRENT_POSITION'
                      | translate)
                  "
                  [placeholder]="
                    'BUSINESS_GROUP.QUESTIONARIES.CURRENT_POSITION_PLACEHOLDER'
                      | translate
                  "
                  [control]="form.controls.currentPosition"
                />
              </div>
              <div class="field-control">
                <app-checkbox
                  [label]="
                    ('BUSINESS_GROUP.QUESTIONARIES.BOARD_POSITION'
                      | translate)
                  "
                  [otherInfo]="
                    'BUSINESS_GROUP.QUESTIONARIES.BOARD_POSITION_HINT'
                      | translate
                  "
                  [control]="form.controls.boardPositions"
                  [options]="[
                    {
                      label:
                        'BUSINESS_GROUP.QUESTIONARIES.CHAIRMAN' | translate,
                      value: 'chairman',
                    },
                    {
                      label:
                        'BUSINESS_GROUP.QUESTIONARIES.VICE_CHAIRMAN'
                        | translate,
                      value: 'vice-chairman',
                    },
                    {
                      label:
                        'BUSINESS_GROUP.QUESTIONARIES.BOARD_MEMBER' | translate,
                      value: 'board-member',
                    },
                  ]"
                />
              </div>
            </div>

            <!-- buttons -->
            <div class="btn-section buttons-group">
              <app-button
                type="submit"
                classesName="btn-edge-cut btn-width-auto"
                [label]="'BUSINESS_GROUP.QUESTIONARIES.SUBMIT' | translate"
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
